import { render, staticRenderFns } from "./ModuloDePesquisaClinica.vue?vue&type=template&id=8b4c6984&"
import script from "./ModuloDePesquisaClinica.vue?vue&type=script&lang=js&"
export * from "./ModuloDePesquisaClinica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports